import { Component, Inject, Input, OnInit } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Services from '@shared/core/services';
import * as Tokens from '@shared/core/tokens';
import { getPickupMessages, getDineInTableMessages, getDineInBuzzerMessages } from '@shared/core/utils/config.utils';

import * as State from '@shared/state';

import { Observable, of } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
    selector: 'shared-order-info',
    templateUrl: './order-info.shared.component.html',
    styleUrls: ['./order-info.shared.component.scss']
})
export class OrderInfoComponent implements OnInit {
    @Input() public preHeaderInverted: boolean = true;
    @Input() public headerInverted: boolean = true;
    @Input() public preHeader: string = 'ORDER SUCCESSFUL';
    @Input() public preHeaderType: OLO.Components.HEADER_TYPE = '5';
    @Input() public preHeaderMarginTop: OLO.Components.MARGIN_SIZE = 'none';
    @Input() public preHeaderMarginBottom: OLO.Components.MARGIN_SIZE = 'xs';
    @Input() public type: OLO.Components.HEADER_TYPE = '2';
    @Input() public marginTop: OLO.Components.MARGIN_SIZE = 'none';
    @Input() public marginBottom: OLO.Components.MARGIN_SIZE = 'md';

    @Input() public orderId: number;
    @Input() public locationNo: number;
    public order$: Observable<State.IOnlineOrderStateItemObj>;
    public locationName$: Observable<string>;
    public locationAddress$: Observable<string>;
    public isDineInOrderType$: Observable<boolean>;
    public isDineInOrderBuzzerType$: Observable<boolean>;
    public tableNo$: Observable<string>;

    public pickupMessages: IOrderConfirmationPage;
    public readonly dineInTableMessages: IOrderConfirmationPage;
    public readonly dineInBuzzerMessages: IOrderConfirmationPage;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) private _config: IConfig,
        public controllers: Controllers,
        public onlineOrdersService: Services.OnlineOrdersService
    ) {
        this.dineInTableMessages = getDineInTableMessages(this._config);
        this.dineInBuzzerMessages = getDineInBuzzerMessages(this._config);
    }

    ngOnInit(): void {
        if (!this.orderId) return;
        this.order$ = this.controllers.historyOrders.getHistoryOrder$(this.orderId);
        this.locationName$ = this.controllers.locations.locationFriendlyName$(this.locationNo);
        this.locationAddress$ = this.controllers.locations.locationAddress$(this.locationNo);
        this.isDineInOrderType$ = this.controllers.historyOrders.isDineInOrder$(this.orderId);
        this.isDineInOrderBuzzerType$ = this.controllers.historyOrders.isDineInOrderBuzzerType$(this.orderId);
        this.tableNo$ = this.controllers.historyOrders.getHistoryOrderTableNo$(this.orderId);

        this.pickupMessages = getPickupMessages(this._config, this.order$);
    }

    public handleOrderMoreClick($event: Event): void {
        this.order$
            .pipe(
                take(1)
            ).subscribe(order => {

                this.controllers.collectionType.patchOrderTypeValue(order.data.OrderTypeId);
                order.data?.OrderTypeDetails?.forEach(typeInfo => {
                    this.controllers.collectionType.patchTableNoValue(typeInfo?.ValueProvided || null);
                });

                this.controllers.routes.navigateToLocation(this.locationNo);
            });
    }

    public get isStatusPlaced$(): Observable<boolean> {
        if (!this.orderId) {
            return of(false);
        }

        return this.controllers.historyOrders.isStatusPlaced$(this.orderId);
    }

    public get isStatusPreparing$(): Observable<boolean> {
        if (!this.orderId) {
            return of(false);
        }

        return this.controllers.historyOrders.isStatusPreparing$(this.orderId);
    }

    public get isStatusActive$(): Observable<boolean> {
        if (!this.orderId) {
            return of(false);
        }

        return this.controllers.historyOrders.isStatusActive$(this.orderId);
    }

    public get isStatusReady$(): Observable<boolean> {
        if (!this.orderId) {
            return of(false);
        }

        return this.controllers.historyOrders.isStatusReady$(this.orderId);
    }
}
